import { render, staticRenderFns } from "./AddImei.vue?vue&type=template&id=5b248e06&scoped=true&"
import script from "./AddImei.vue?vue&type=script&lang=js&"
export * from "./AddImei.vue?vue&type=script&lang=js&"
import style0 from "./AddImei.vue?vue&type=style&index=0&id=5b248e06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b248e06",
  null
  
)

export default component.exports